module.exports = __webpack_public_path__ + "567d858b.png";